import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/authentication-service/authentication.service';



/**
 * Angular guard function that checks if the user is logged in or not.
 *
 * If not, user is redirected to the login page.
 *
 * This guard is used to prevent unauthenticated users from accessing the
 * application pages and force user to login first.
 *
 * @param route Standard route
 * @param state
 * @returns
 */
export const authGuard: CanActivateFn = () => {
  const authSrvc = inject(AuthenticationService);
  const router = inject(Router);

  if (!authSrvc.isUserLoggedIn()) {
    // Redirect to the login page
    return router.parseUrl('/login');
  }
  return true;
};
